import React from 'react';
import {EgovRequest} from "../../../components";

const Request = () => {
    return <EgovRequest/>
};

export default Request;
